import React from 'react';
import { Form, Button, Select, Cascader, Row, Col } from 'antd';
import { CATEREFTYPEENUM } from './../../config';

// 父级过滤器，静态，缓存下
const ParentFilter = React.memo(({ parentForm, categoryList, handleOnFinish }) => {
  return (
    <div className="cross-filter-content">
      <div className="filter-header ">找到适合你的跨品类合作</div>
      <Form
        layout={'vertical'}
        form={parentForm}
        initialValues={{ mainCid: [], refType: CATEREFTYPEENUM['0'].key }}
        onFinish={handleOnFinish}
      >
        <Row gutter={16}>
          <Col flex="240px">
            <Form.Item label={<span style={{ color: '#fff' }}>选择你的品类：</span>} name="mainCid">
              <Cascader
                expandTrigger="hover"
                fieldNames={{ label: 'name', value: 'fullPath' }}
                options={categoryList}
                placeholder="请选择品类"
                changeOnSelect
              />
            </Form.Item>
          </Col>
          <Col flex="136px">
            <Form.Item label={<span style={{ color: '#fff' }}>查询商品类型：</span>} name="refType">
              <Select placeholder="请选择商品商品类型">
                {Object.values(CATEREFTYPEENUM) &&
                  Object.values(CATEREFTYPEENUM)?.map((item) => {
                    return (
                      <Select.Option value={item.key} key={item.key}>
                        {item.name}
                      </Select.Option>
                    );
                  })}
              </Select>
            </Form.Item>
          </Col>
          <Col flex="80px">
            <Form.Item>
              <Button type="primary" shape="round" htmlType="submit" className="cross-search-btn">
                查询
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
});

export default ParentFilter;
